export const screens = {
  main: "/",
  tapThat: {
    main: "/TapThat",
    simpleGame: "/TapThat/play",
    instructions: "/TapThat/howTo",
    highScore: "/TapThat/highScore",
  },
  precisionClicker: {
    main: "/PrecisionClicker",
    play: "/PrecisionClicker/play",
    howTo: "/PrecisionClicker/howTo",
    highScore: "/PrecisionClicker/highScore",
  },
};
